import { render, staticRenderFns } from "./secBanner.vue?vue&type=template&id=1f3ebc38&scoped=true&"
import script from "./secBanner.vue?vue&type=script&lang=js&"
export * from "./secBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ebc38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3ebc38')) {
      api.createRecord('1f3ebc38', component.options)
    } else {
      api.reload('1f3ebc38', component.options)
    }
    module.hot.accept("./secBanner.vue?vue&type=template&id=1f3ebc38&scoped=true&", function () {
      api.rerender('1f3ebc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/secBanner.vue"
export default component.exports